import { Mail, Phone, MapPin, ArrowUpRight } from "lucide-react";

export default function Contact() {
  const contactInfo = [
    {
      icon: Phone,
      title: "Телефон",
      details: "+7 (901) 000-04-06",
      href: "tel:+79010000406",
    },
    {
      icon: Mail,
      title: "Эл. почта",
      details: "info@bart-group.ru",
      href: "mailto:info@bart-group.ru",
    },
    {
      icon: MapPin,
      title: "Офис",
      details: "ул. Строительная, 123",
      href: "#",
    },
  ];

  return (
    <section className="relative overflow-hidden bg-white py-24 text-slate-950">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-16 lg:grid-cols-2 lg:gap-24">
          <div>
            <div className="mb-10 flex items-center gap-4">
              <span className="h-px w-10 bg-[#147f8f]" />
              <span className="text-sm font-bold uppercase tracking-[0.35em] text-[#147f8f]">
                Начать проект
              </span>
            </div>

            <h2 className="mb-8 text-4xl leading-[1.08] tracking-[-0.04em] text-slate-950 md:text-5xl lg:text-6xl">
              <span className="block font-semibold">Давайте обсудим,</span>
              <span className="block font-light text-slate-400">
                что вы хотите построить.
              </span>
            </h2>

            <p className="mb-10 max-w-2xl text-lg leading-[1.8] text-slate-600 md:text-xl">
              Расскажите нам о вашем участке, сроках и задачах. Мы подготовим
              понятное предложение и реалистичный бюджет для вашего проекта.
            </p>

            <a
              href="mailto:info@bart-group.ru"
              className="group inline-flex items-center gap-4 rounded-sm bg-[#147f8f] px-6 py-4 font-semibold text-white shadow-lg shadow-[#147f8f]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-slate-950 hover:shadow-slate-950/20"
            >
              Получить расчёт
              <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
          </div>

          <div className="space-y-5">
            {contactInfo.map((info) => {
              const Icon = info.icon;

              return (
                <a
                  key={info.title}
                  href={info.href}
                  className="group block rounded-sm border border-slate-200 bg-white px-8 py-8 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-[#147f8f]/40 hover:shadow-xl hover:shadow-slate-200/70"
                >
                  <div className="flex items-center gap-7">
                    <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-[#147f8f]/10 text-[#147f8f] transition-all duration-300 group-hover:bg-[#147f8f] group-hover:text-white">
                      <Icon className="h-5 w-5" />
                    </div>

                    <div className="min-w-0 flex-1">
                      <p className="mb-3 text-sm uppercase tracking-[0.25em] text-slate-400">
                        {info.title}
                      </p>
                      <p className="truncate text-lg font-semibold text-slate-950">
                        {info.details}
                      </p>
                    </div>

                    <ArrowUpRight className="h-5 w-5 text-slate-300 transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-[#147f8f]" />
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}